<template>
  <div>
    <div class="space-y-5 p-2 sm:p-5 sm:py-0 md:pt-5">
      <!-- Page Header -->
      <div class="flex items-center justify-between gap-x-5">
        <Breadcrumbs
          :items="[
            { title: 'Dashboard', to: ROUTES.ADMIN.DASHBOARD },
            { title: 'Feedback', to: ROUTES.ADMIN.FEEDBACK.FEEDBACK_LIST }
          ]"
        />
      </div>
      <!-- End Page Header -->

      <!-- Feedback Table Card -->
      <div class="flex flex-col space-y-4 rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
        <div>
          <!-- Tab Content -->
          <div class="">
            <!-- Table Section -->
            <div
              class="[&amp;::-webkit-scrollbar]:h-2 [&amp;::-webkit-scrollbar-thumb]:rounded-full
                [&amp;::-webkit-scrollbar-track]:bg-gray-100 [&amp;::-webkit-scrollbar-thumb]:bg-gray-300
                &amp;::-webkit-scrollbar-track]:bg-neutral-700 &amp;::-webkit-scrollbar-thumb]:bg-neutral-500
                overflow-x-auto"
            >
              <div class="inline-block min-w-full align-middle">
                <!-- Table -->
                <PaginatedTableView
                  :fetchData="fetchFeedback"
                  searchableFields="UUID or feature"
                >
                  <template #table-head>
                    <TableCell>UUID</TableCell>
                    <TableCell>Feature</TableCell>
                    <TableCell>Rating</TableCell>
                    <TableCell>Has Comment</TableCell>
                    <TableCell>Customer</TableCell>
                    <TableCell></TableCell>
                  </template>
                  <template #table-row="{ items: feedbackItems }: { items: SuperUserFeedback[] }">
                    <TableRow
                      v-for="feedback in feedbackItems"
                      :key="feedback.uuid"
                    >
                      <UniqueTableDataCell :truncate="true">
                        <router-link
                          :to="
                            ROUTES.ADMIN.FEEDBACK.FEEDBACK_DETAIL.replace(':uuid', feedback.uuid)
                          "
                        >
                          {{ feedback.uuid }}
                        </router-link>
                      </UniqueTableDataCell>
                      <TableCell>
                        {{ feedback.feature }}
                      </TableCell>
                      <TableCell>
                        {{ feedback.rating }}
                      </TableCell>
                      <TableCell>
                        {{ feedback.comment ? 'Yes' : 'No' }}
                      </TableCell>
                      <CustomerTableDataCell :org="feedback.user?.org" />
                      <TableCell>
                        <router-link
                          class="inline-flex items-center gap-x-2 rounded-lg border border-transparent text-sm font-semibold
                            text-blue-600 hover:text-blue-800 disabled:pointer-events-none disabled:opacity-50
                            dark:text-blue-500 dark:hover:text-blue-400"
                          :to="
                            ROUTES.ADMIN.FEEDBACK.FEEDBACK_DETAIL.replace(':uuid', feedback.uuid)
                          "
                          type="button"
                        >
                          Details
                        </router-link>
                      </TableCell>
                    </TableRow>
                  </template>
                </PaginatedTableView>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { FeedbackService } from '@/types/generated/services.gen'
  import { type SuperUserFeedback } from '@/types/generated'
  import PaginatedTableView, {
    type FetchDataOptions,
    type PaginatedResponse
  } from '@/components/admin/PaginatedTable.vue'
  import { ROUTES } from '@/router/routes'
  import UniqueTableDataCell from '@/components/admin/table/UniqueTableDataCell.vue'
  import Breadcrumbs from '@/components/admin/breadcrumbs/Breadcrumbs.vue'
  import { TableRow, TableCell } from '@/components/ui/table'
  import CustomerTableDataCell from '@/components/admin/table/CustomerTableDataCell.vue'

  const fetchFeedback = async (
    options?: FetchDataOptions
  ): Promise<PaginatedResponse<SuperUserFeedback>> => {
    return FeedbackService.feedbackList({
      limit: options?.limit,
      offset: options?.offset
    }) as unknown as PaginatedResponse<unknown>
  }
</script>

<style scoped></style>
